// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { getToken, removeUserInfo } from '@/utils/auth'
import { getWebConfig } from "@/utils/config";
import { Toast } from 'vant'
import store from '@/store'
import { consumeTokenFromUrl } from '@/utils/tokenLogin'
import { clearApiCache } from '@/utils/apiCache'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home/index.vue'),
        meta: {
            title: '首页',
            requiresAuth: true
        }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/ForgotPassword/index.vue'),
        meta: {
            title: '忘记密码'
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/Profile/index.vue'),
        meta: {
            title: '个人中心',
            requiresAuth: true
        }
    },
    {
        path: '/app-download',
        name: 'AppDownload',
        component: () => import('@/views/AppDownloadPage/index.vue'),
        meta: {
            title: 'APP下载',
        }
    },
    {
        path: '/mall',
        name: 'Mall',
        component: () => import('@/views/Mall/index.vue'),
        meta: {
            title: '产品',
        }
    },
    {
        path: '/phone',
        name: 'Phone',
        component: () => import('@/views/Phone/index.vue'),
        meta: {
            title: '免费领手机',
            requiresAuth: true
        }
    },
    {
        path: '/phone-get',
        name: 'PhoneGet',
        component: () => import('@/views/PhoneGet/index.vue'),
        meta: {
            title: '我的礼品',
            requiresAuth: true
        }
    },
    {
        path: '/cash-grab',
        name: 'CashGrab',
        component: () => import('@/views/CashGrab/index.vue'),
        meta: {
            title: '现金红包',
            requiresAuth: true
        }
    },
    {
        path: '/prosperity-fund',
        name: 'ProsperityFund',
        component: () => import('@/views/ProsperityFund/index.vue'),
        meta: {
            title: '共富基金',
            requiresAuth: true
        }
    },
    {
        path: '/credit-repair',
        name: 'CreditRepair',
        component: () => import('@/views/CreditRepair/index.vue'),
        meta: {
            title: '征信修复',
            requiresAuth: true
        }
    },
    {
        path: '/card-fee',
        name: 'CardFee',
        component: () => import('@/views/CardFee/index.vue'),
        meta: {
            title: '国际卡工本费缴纳',
            requiresAuth: true
        }
    },
    {
        path: '/card-pin',
        name: 'CardPin',
        component: () => import('@/views/CardPin/index.vue'),
        meta: {
            title: '设置密码',
            requiresAuth: true
        }
    },
    {
        path: '/card-types',
        name: 'CardTypes',
        component: () => import('@/views/CardType/index.vue'),
        meta: {
            title: '卡类型选择',
            requiresAuth: true
        }
    },
    {
        path: '/limit-activation',
        name: 'LimitActivation',
        component: () => import('@/views/LimitActivation/index.vue'),
        meta: {
            title: '额度启用',
            requiresAuth: true
        }
    },
    {
        path: '/orders',
        name: 'OrderList',
        component: () => import('@/views/Mall/OrderList/index.vue'),
        meta: {
            requiresAuth: true,
            title: '我的订单'
        }
    },
    {
        path: '/address',
        name: 'Address',
        component: () => import('@/views/AddressManagement/index.vue'),
        meta: {
            requiresAuth: true,
            title: '地址管理'
        }
    },
    {
        path: '/address/add',
        name: 'AddressAdd',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/address/edit/:id',
        name: 'AddressEdit',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/bank-cards',
        name: 'BankCards',
        component: () => import('@/views/BankCard/index.vue'),
        meta: {
            requiresAuth: true,
            title: '银行卡管理'
        }
    },
    {
        path: '/verification',
        name: 'Verification',
        component: () => import('@/views/Verification/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/security',
        name: 'Security',
        component: () => import('@/views/Security/index.vue'),
        meta: {
            title: '安全中心',
            requiresAuth: true
        }
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('@/views/Help/index.vue'),
        meta: {
            title: '帮助中心',
            requiresAuth: true
        }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About/index.vue'),
        meta: {
            title: '关于我们',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw',
        name: 'Withdraw',
        component: () => import('@/views/Withdraw/index.vue'),
        meta: {
            title: '提现',
            requiresAuth: true
        }
    },
    {
        path: '/equity-dividend-withdraw',
        name: 'EquityDividendWithdraw',
        component: () => import('@/views/EquityDividendWithdraw/index.vue'),
        meta: {
            title: '提现到国际卡',
            requiresAuth: true
        }
    },
    {
        path: '/recharge-account',
        name: 'RechargeAccount',
        component: () => import('@/views/RechargeAccount/index.vue'),
        meta: {
            title: '充值账户',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-bind',
        name: 'WithdrawBind',
        component: () => import('@/views/WithdrawBind/index.vue'),
        meta: {
            title: '提现信息绑定',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-asset',
        name: 'WithdrawAsset',
        component: () => import('@/views/WithdrawAsset/index.vue'),
        meta: {
            title: '提现到资产余额',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-history',
        name: 'WithdrawHistory',
        component: () => import('@/views/WithdrawHistory/index.vue'),
        meta: {
            title: '提现明细',
            requiresAuth: true
        }
    },
    {
        path: '/asset-history',
        name: 'AssetHistory',
        component: () => import('@/views/AssetHistory/index.vue'),
        meta: {
            title: '资产明细',
            requiresAuth: true
        }
    },
    {
        path: '/bind-bank-card',
        name: 'BindBankCard',
        component: () => import('@/views/BindBankCard/index.vue'),
        meta: {
            title: '绑定银行卡',
            requiresAuth: true
        }
    },
    {
        path: '/real-name',
        name: 'RealName',
        component: () => import('@/views/RealName/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/team',
        name: 'Team',
        component: () => import('@/views/Team/index.vue'),
        meta: {
            title: '我的团队',
            requiresAuth: true
        }
    },
    {
        path: '/invite',
        name: 'Invite',
        component: () => import('@/views/Invite/index.vue'),
        meta: {
            title: '邀请好友',
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login/index.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/Register/index.vue'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/download/guide',
        name: 'downloadGuide',
        component: () => import('@/views/DownloadGuidePage/index.vue'),
        meta: {
            title: '下载指引'
        }
    },
    {
        path: '/403',
        name: '403',
        component: () => import('@/views/error/403.vue'),
        meta: {
            title: '无权访问'
        }
    },
    {
        path: '/monthly-sign-in',
        name: 'MonthlySignIn',
        component: () => import('@/views/MonthlySignIn/index.vue'),
        meta: {
            title: '月度签到',
            requiresAuth: true
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/views/error/404.vue'),
        meta: {
            title: '页面未找到'
        }
    },
    {
        path: '/gift',
        name: 'Gift',
        component: () => import('@/views/Gift/index.vue'),
        meta: {
            title: '抽奖',
        }
    },
    {
        path: '/gift-history',
        name: 'GiftHistory',
        component: () => import('@/views/GiftHistory/index.vue'),
        meta: {
            title: '中奖记录',
        }
    },
    {
        path: '/stock',
        name: 'Stock',
        component: () => import('@/views/Stock/index.vue'),
        meta: {
            title: '股票中心',
        }
    },
    {
        path: '/equity-certificate',
        name: 'EquityCertificate',
        component: () => import('@/views/EquityCertificate/index.vue'),
        meta: {
            title: '股权证书',
            requiresAuth: true
        }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        // 始终滚动到顶部
        return { top: 0 }
    }
})

// 白名单：不需要登录就可以访问的路由
const whiteList = ['/login', '/register', '/forgot-password', '/403', '/404', '/app-download', '/download/guide']

router.beforeEach(async (to, from, next) => {
    const webConfig = getWebConfig();
    const web_name = webConfig?.web_name || "";
    document.title = to.meta.title ? `${to.meta.title} - ${web_name}` : `${web_name}`

    // 兜底：路由跳转前再消费一次（防止首屏未吃到 token）
    const usedAdminLoginLink = consumeTokenFromUrl()
    if (usedAdminLoginLink) {
        const t = getToken()
        if (t) {
            store.commit('user/SET_TOKEN', t)
            removeUserInfo()
            store.commit('user/SET_USER_INFO', null)
            clearApiCache()
        }
    }

    const token = getToken() || store.state.user.token
    if (token && !store.state.user.token) {
        store.commit('user/SET_TOKEN', token)
    }

    // 判断是否有token
    if (token) {
        if (to.path === '/login' || to.path === '/register') {
            // 已登录状态下访问登录页，重定向到首页
            next('/')
        } else {
            // 判断是否已经获取了用户信息
            if (store.state.user.userInfo) {
                next()
            } else {
                try {
                    // 获取用户信息
                    await store.dispatch('user/getUserInfo')
                    next()
                } catch (error) {
                    const status = error?.response?.status
                    console.error('路由获取用户信息失败', status, error)
                    // 仅鉴权失败才清登录态；其它错误避免误踢回登录页
                    if (status === 401) {
                        await store.dispatch('user/logout')
                        Toast.fail('登录状态已过期，请重新登录')
                        next(`/login?redirect=${to.path}`)
                    } else {
                        Toast.fail('获取用户信息失败，请稍后重试')
                        next()
                    }
                }
            }
        }
    } else {
        // 没有token
        if (whiteList.includes(to.path) || to.path.startsWith('/download/') || !to.meta.requiresAuth) {
            // 白名单中的页面或不需要认证的页面，直接访问
            next()
        } else {
            // 其他需要登录的页面，重定向到登录页
            next(`/login?redirect=${to.path}`)
        }
    }
})

export default router